module.exports = __webpack_public_path__ + "static/media/VHS_Door.8629a504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/VHS_Door.svg
// module id = 34
// module chunks = 1